var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleTv = function SvgAppleTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 93,
    height: 93,
    rx: 10.5,
    stroke: "#fff",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple_tv_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.912 39.688A5.13 5.13 0 0 0 39.116 36a5.11 5.11 0 0 0-3.433 1.763 4.822 4.822 0 0 0-1.231 3.54 4.35 4.35 0 0 0 3.46-1.615ZM39.034 41.545c-1.915-.108-3.53 1.076-4.446 1.076-.916 0-2.311-1.023-3.816-.995a5.628 5.628 0 0 0-4.787 2.893c-2.052 3.5-.547 8.707 1.45 11.56.97 1.36 2.134 2.975 3.68 2.92 1.545-.053 2.024-.941 3.788-.941 1.764 0 2.284.942 3.816.902 1.532-.04 2.6-1.36 3.557-2.827.683-1.009 1.23-2.1 1.6-3.257-1.874-.82-3.091-2.65-3.105-4.67.027-1.79.971-3.431 2.503-4.387a5.462 5.462 0 0 0-4.24-2.288M51.248 38.826v3.85h3.12v2.53h-3.12v9.097c0 1.36.616 2.046 1.984 2.046.37 0 .752-.027 1.121-.081v2.557c-.615.094-1.23.148-1.846.135-3.228 0-4.473-1.239-4.473-4.334v-9.353h-2.448v-2.544h2.38v-3.89h3.282v-.013ZM65.269 58.825h-3.42l-5.744-16.096h3.405l4.035 12.933h.082l4.036-12.933H71L65.27 58.825Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apple_tv_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(25 36)",
    d: "M0 0h46v23H0z"
  })))));
};
export default SvgAppleTv;